export default __webpack_public_path__ + "static/media/save-tick.f8586e34.svg";